import { motion, AnimatePresence } from 'framer-motion'
import Swiper from 'swiper'
import { FC, ReactNode } from 'react'

import { Container } from 'components/container'
import { containerVariants, variants } from './variants'
import {
  Description,
  NavButton,
  NavTitle,
  NavTitleContainer,
  Navigation as StyledNavigation,
  Title,
} from './styled'

type Props = {
  swiper: React.MutableRefObject<Swiper | undefined>
  title: string
  description?: ReactNode
  titleInNav?: boolean
  smallTitleSpacing?: boolean
}

export const Navigation: FC<Props> = ({
  swiper,
  title,
  description,
  titleInNav,
  smallTitleSpacing,
}) => (
  <Container>
    <StyledNavigation>
      <NavButton
        aria-label="Previous"
        onClick={() => swiper.current?.slidePrev()}
      >
        <svg
          width="9"
          height="15"
          viewBox="0 0 9 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.528531 6.91986C0.138031 7.31039 0.138031 7.94355 0.528531 8.33408L6.89253 14.698C7.28303 15.0886 7.91623 15.0886 8.30673 14.698C8.69723 14.3075 8.69723 13.6744 8.30673 13.2838L2.64993 7.62697L8.30673 1.97014C8.69723 1.57964 8.69723 0.946443 8.30673 0.555943C7.91623 0.165343 7.28303 0.165343 6.89253 0.555943L0.528531 6.91986Z"
            fill="currentColor"
          />
        </svg>
      </NavButton>

      {titleInNav && (
        <AnimatePresence mode="wait">
          <NavTitleContainer
            key={title}
            $smallTitle={smallTitleSpacing}
            variants={containerVariants}
            initial="hidden"
            animate="enter"
            exit="leave"
          >
            <NavTitle
              variants={variants}
              $noHyphens
              $smallTitle={smallTitleSpacing}
            >
              {title}
            </NavTitle>
          </NavTitleContainer>
        </AnimatePresence>
      )}

      <NavButton aria-label="Next" onClick={() => swiper.current?.slideNext()}>
        <svg
          width="9"
          height="15"
          viewBox="0 0 9 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.30692 8.33407C8.69742 7.94354 8.69742 7.31038 8.30692 6.91985L1.94291 0.555894C1.55241 0.165369 0.919215 0.165369 0.528715 0.555893C0.138215 0.946417 0.138215 1.57958 0.528715 1.9701L6.18551 7.62696L0.528715 13.2838C0.138215 13.6743 0.138215 14.3075 0.528715 14.698C0.919215 15.0886 1.55241 15.0886 1.94291 14.698L8.30692 8.33407Z"
            fill="currentColor"
          />
        </svg>
      </NavButton>
    </StyledNavigation>

    <AnimatePresence mode="wait">
      <motion.div
        key={title}
        variants={containerVariants}
        initial="hidden"
        animate="enter"
        exit="leave"
      >
        {!titleInNav && <Title variants={variants}>{title}</Title>}
        {!!description && (
          <Description variants={variants}>{description}</Description>
        )}
      </motion.div>
    </AnimatePresence>
  </Container>
)
